<template>
    <div :class="{'pro-list':true}" v-show='showList' id='list'>
        <div :class="{blur:isblur,products:true}">
            <ul class="clearfix">
                <li class="pro-li" v-for="(item,index) in sdata.source.goods" @click='cartDialog($event,item)'>
                    <div class="pro-liimg">
                        <router-link :to="'/detail/'+item.id">
                            <img v-lazy='item.img' v-if='item.img'>
                            <!-- <goodsOver v-if="item.useFlg!=1"></goodsOver> -->
                        </router-link>
                    </div>
                    <div class="pro-content ">
                        <div class="name_wrap clearfix">
                            <div>
                                <div class='pro_item_list'>
                                    <div class='cake_name'>
                                        <div class="p1 clearfix">
                                            <span class="title fl">{{item.name}}</span>
                                            <span v-if="item.tag" class="label">{{item.tag}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="p2 clearfix text-overflow" style="width: 100%;">
                                    <span class="fl">{{item.french}}</span>
                                </div>
                            </div>
                            <span class="cart-icon" data-target='1' :data-id='item.id' :data-img='item.img'></span>
                        </div>
                        <div class="p3 clearfix">
                          <span class="fl">
                            <span class="price" v-if="item.price=item.pprice||!item.pprice"><b>￥</b>{{item.price}}</span> 
                            <span class="pprice" v-else><b>￥</b>{{item.pprice}}</span> 
                            <span class="label" v-else>折扣价</span>
                          </span>
                        </div>
                    </div>
                </li>
            </ul>
            <!-- <div class="more_wrap" @click='loadMore'>
                <p>查看更多</p>
                <img src="/static/images/icon_proMore.png">
            </div> -->
        </div>
        <cartDialog v-on:closeDialog='closeDialog' v-show='isShowDialog' :cartModel='cartModel' :item='cartItem'
                    :showCart='isShowDialog'></cartDialog>
    </div>
</template>
<script>
  import dialog from '../components/dialog'
  import cartDialog from '../components/cart-dialog'
  import goodsOver from '../components/goods_over'
  import '../style/css/cart.css'
  import { mapActions } from 'vuex'

  export default {
    name: 'list',
    components: {
      myDialog: dialog,
      cartDialog,
      goodsOver
    },
    data () {
      return {
        loading: false,
        isblur: false,
        showChildMsg: '',
        isShowDialog: false,
        prolist: [],
        data: '',
        value: 1,
        isload: false,
        addtype: 1,// 1加入购物车 2立刻购买
        cartItem: '',
        page: 0,
        count: '',
        isloadAll: false,
        ismounted: true,
        iswatch: false,
        isrouter: false,
        ischange: false,
        showList: true,
        nomore: true,
        isget: false,
        cartnum: {
          num: 0
        },
        top: 0,
        cartModel: {
          num: 0
        },
        leave: false,
        isin: 0
      }
    },
    filters: {},
    props: ['id', 'isChangeList', 'clear', 'sdata'],
    // 缓存了组件后需要调用该方法
    activated () {

    },
    watch: {
      isChangeList: {
        handler (newValue, oldValue) {
          if (this.isChangeList.num == 1) {
            return false
          }
          if (this.$route.path.includes('/home') || this.$route.path.includes('/list')) {
            this.prolist = []
            this.leave = false
            this.isload = true
            this.isloadAll = false
            this.iswatch = false
            this.loading = false
            this.nomore = false
            this.page = 0
            this.getList(1)
          }
        },
        deep: true
      }
    },
    mounted () {
    },
    methods: {
      getItem () {

      },
      getGoodsDetail (id, img) {
        let self = this
        self.Loading.open()
        self.$http.get(self.host + '/api/cc69f751ce690b6f', {
          params: {
            id: id,
            client: 2
          }
        }).then(function (res) {
          self.Loading.close()
          self.loading = false
          if (res.code == 1) {
            if (self.addtype) {
              self.cartItem = res.data
              self.cartItem.baseImg = img
              self.cartItem.cartName = self.addtype == 1 ? 'shop' : 'nowbuy'
              self.isShowDialog = true
              self.isblur = true
            }
          }
          self.isload = true
        }, function (error) {
        })
      },
      insure () {
        if (this.addtype == 1) {
          this.MessageBox({
            closeOnClickModal: false,
            title: '提示',
            message: desc,
            confirmButtonText: '加入购物车成功'
          })
          this.isblur = this.isShowDialog = false
        } else {
          this.isblur = this.isShowDialog = false
          this.$router.push('/nowbuy')
        }
      },
      loadMore () {
        this.$router.push('/cake');
        if (this.leave) {
          return false
        }
        if (!this.isload) {
          return false
        }
        if (this.isloadAll) {
          return false
        }
        if (this.iswatch) {
          return false
        }
        if (this.loading) {
          return false
        }
        if (this.nomore) {
          return false
        }
        this.getList(1)
      },
      cartDialog (e, item) {
        if (item.name == '月明·流苏礼盒') {
          this.MessageBox({
            closeOnClickModal: false,
            title: '提示',
            message: '月饼卡请拨打<a href="tel:4006-678-678" style="color:#2700ff;">4006-678-678</a>兑换',
            showCancelButton: false,
            cancelButtonText: '继续逛逛'
          }).then(action => {
          })
          return false
        }
        this.cartModel.num++
        let id = e.target.dataset.id
        let img = e.target.dataset.img
        if (id && img) {
          this.addtype = e.target.dataset.target
          this.cartItem = item
          this.cartItem.cartName = this.addtype == 1 ? 'shop' : 'nowbuy'
          this.isShowDialog = true
          this.isblur = true
          return false
        }
      },
      closeDialog (num) {
        this.isblur = this.isShowDialog = false
        if (num) {
          this.cartnum.num = num
          this.clear.num += 1
        }
      },
      getList: function (isrefresh, type) {
        if (!isrefresh)
          return false
        if (!store.get('city_id'))
          return false
        var self = this
        if (self.loading) {
          return false
        }
        self.loading = true
        if ((self.count == self.prolist.length) && self.count) {
          self.isloadAll = true
          return false
        }
        var data = {
          cityId: store.get('city_id'),
          page: self.page + 1,
          bid: self.sdata.bid,
          size: self.sdata.size,
          tid: self.sdata.tid
        }
        self.$http.get(self.host + '/api/0434b49d1ac28f9d', {
          params: data
        }).then(function (res) {
          self.loading = false
          self.iswatch = false
          self.nomore = false
          self.isget = true
          self.showList = true
          if (res.code == 1) {
            if (type) {
              self.prolist = []
            }
            if (type) {
              self.page = 1
            } else {
              self.page++
            }
            self.count = res.data.count
            let list = res.data.list
            for (let i = 0; i < list.length; i++) {
              self.prolist.push(list[i])
            }
            if (self.prolist.length == 0) {
              self.$emit('onData', false)
            } else {
              self.$emit('onData', true)
            }

            if (list.length < self.sdata.size || list.length % 2 == 1) {
              self.isloadAll = true
            }
            if (list.length == 0) {
              return false
            }
          }
          self.isload = true
        }, function (error) {
          console.log(error)
        })
      }
    }
  }
</script>
<style scoped>
    .pro_item_list {
        display: flex;
    }

    .pro_item_list .cake_name {
        flex: 4;
    }

    .pro_item_list .title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        /*width: 80%;*/
        max-width: 80%;
    }

    .pro_item_list .label {
        float: left;
        background-color: #ffe32a;
        font-size: .186666667rem;
        display: inline-block;

        line-height: .266666667rem;
        padding: .02rem .1rem 0;
        margin-top: 0.01rem;
        margin-left: 0.1rem;
    }

    .p3 .label {
        background-color: #ff333a;
        color: #fff;
        font-size: .185rem;
        display: inline-block;
        line-height: .266666667rem;
        padding: .02rem .1rem 0;
        margin-top: 0.01rem;
        margin-left: 0.1rem;
        border-radius:.266666667rem;
        padding: 0.02rem 0.15rem;
    }

    .products ul {
        display: flex;
        flex-flow: row wrap;
        padding-bottom: 0.6rem;
    }

    .products ul li {
        overflow: hidden;
        float: none;
    }
    .pro-li{margin-bottom: 0.6rem;}
    .price{ font-weight: bold;}
    .pprice{font-weight: bold; color:#ff3744;}

    .pro-list {
        min-height: 100%;
        border-bottom: 1px solid #dfdfdf;
    }

    .pro-list.isless {
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
        padding-top: 1.6rem;
        background-color: #f9f9f9;
    }

    .pro-list .nopro {
        font-size: .4rem;
        background-color: #f9f9f9;
        margin: 1rem auto;
        width: 100%;
    }

    .more_wrap {
        font-size: .3rem;
        color: #8b8b8b;
        text-align: center;
        font-weight: bold;
    }

    .more_wrap img {
        width: .48rem !important;
        margin-top: .1rem;
    }

    .products {
        padding-bottom: 0.2rem;
    }

    .products ul li .pro-liimg {
        background-image: url(/static/images/pro_bc.png);
        background-size: cover;
        min-width: 4.68rem;
        min-height: 4.68rem;
    }

    .products ul li .fl {
        font-size: .3rem;
    }

    .products ul li .p2 .fl {
        font-size: .186666667rem;
    }

    .products ul li .p3 .fl {
        font-weight: normal;
        line-height: .3rem;
    }

    .products ul li .p3 {
        padding: 0;
        margin: 0;
        padding-left: .1rem;
    }

    .products ul li .p3 .fl b {
        font-size: .186666667rem;
    }

    .name_wrap {
        position: relative;
    }

    .name_wrap > div {
        float: left;
        width: 3.6rem;
    }

    .products ul li .cart-icon {
        margin-top: .1rem;
        margin-right: .2rem;
    }

    .products ul li .p1 {
        padding-left: .1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/home_pro_list.vue